import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@fiverr-private/fit';

const isEllipsisActive = (el) => el.offsetHeight < el.scrollHeight || el.offsetWidth < el.scrollWidth;

/** @type {React.FC<{className?: string, text: React.ReactNode}>} */
export const TitleEllipsisPopover = ({ className, text }) => {
    /** @type {React.RefObject<HTMLDivElement|null>} */
    const titleRef = useRef(null);
    const [isEllipsis, setIsEllipsis] = useState(false);

    useEffect(() => {
        if (titleRef.current) {
            setIsEllipsis(isEllipsisActive(titleRef.current));
        }
    }, [titleRef]);

    if (isEllipsis) {
        return (
            <Tooltip delay={300} content={text} appendToBody={true}>
                <div className={className}>{text}</div>
            </Tooltip>
        );
    }

    return (
        <div className={className} ref={titleRef}>
            {text}
        </div>
    );
};

TitleEllipsisPopover.propTypes = {
    className: PropTypes.string,
    text: PropTypes.string,
};
